import { Separator } from '../separator'
import { Skeleton } from '../skeleton'

const IdeaCardSkeleton = () => {
  return (
    <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div className="flex items-start gap-4 p-6">
        <Skeleton className="size-8 rounded-full" />
        <Skeleton className="h-6 flex-1" />
      </div>

      <div className="space-y-4 p-6 pt-0">
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>

        <div className="flex items-center gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center gap-1">
              <Skeleton className="size-4" />
              <Skeleton className="h-4 w-8" />
            </div>
          ))}
        </div>

        <Separator className="animate-pulse bg-muted" />

        <div className="flex gap-6">
          <div className="flex-1">
            <div className="flex -space-x-2">
              {Array.from({ length: 3 }).map((_, i) => (
                <Skeleton
                  key={i}
                  className="size-8 rounded-full border-2 border-background"
                />
              ))}
            </div>
          </div>

          <Skeleton className="h-6 w-24 rounded-full" />
        </div>

        <div className="mt-4 rounded-lg">
          <div className="flex items-center gap-2">
            <Skeleton className="size-4" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        </div>
      </div>
    </div>
  )
}
IdeaCardSkeleton.displayName = 'IdeaCardSkeleton'

export { IdeaCardSkeleton }
